// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__RNVoH","container":"NotFound_container__LKmIu","title":"NotFound_title__c7TGR","video_item":"NotFound_video_item__KMH6y"};